export default __webpack_public_path__ + "static/eco-impact-hero-78926877b914b0f599109a18aa0e8671.jpg";